import type { JSX } from 'react';
import type { AlertProps } from './Alert.d';

import { Alert as FriskAlert } from '@hdir/ui/alert';
import cx from 'clsx';
import React, {useState} from 'react';

export const Alert = ({
	children,
	className,
	isClosable,
	...otherProps
}: AlertProps): JSX.Element | null => {
	const [open, setOpen] = useState(true);

	if (!open) {
		return null;
	}

	return (
		<FriskAlert
			{...otherProps}
			className={cx(className)}
			onClose={
				isClosable
					? () => setOpen(prev => !prev)
					: undefined
			}
		>
			{children}
		</FriskAlert>
	);
};
